import { Typography } from '@material-ui/core'
import { Labeled } from 'react-admin'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { Text } from 'shared/components/Text/Text'
import { midGray } from 'shared/theme/colors'

import {
  BrokerCreditRatingBackgroundColorMap,
  BrokerCreditRatingCategory,
  BrokerCreditRatingCategoryTextMap,
  BrokerCreditRatingFontColor,
} from 'models/jobs'

interface BrokerCreditRatingLabelProps {
  creditRating: string
  creditRatingCategory: string
  creditRatingCategoryName: string
  paddingName: string
  paddingScore: string
  isHorizontal?: boolean
}

export const BrokerCreditRatingLabel = ({
  creditRating,
  creditRatingCategory,
  creditRatingCategoryName,
  paddingName,
  paddingScore,
  isHorizontal,
}: BrokerCreditRatingLabelProps) => {
  const fontColor = BrokerCreditRatingFontColor[creditRatingCategory as BrokerCreditRatingCategory]
  const backgroundColor =
    BrokerCreditRatingBackgroundColorMap[creditRatingCategory as BrokerCreditRatingCategory]

  function creditRatingAndCategory() {
    return (
      <>
        {!isNaN(parseInt(creditRating)) && (
          <Typography
            component="span"
            style={{
              width: '25px',
              height: '25px',
              alignItems: 'center',
              color: fontColor,
              backgroundColor: backgroundColor,
              fontFamily: 'Overpass',
              fontWeight: 600,
              borderRadius: '50%',
              fontSize: '16px',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {parseInt(creditRating)}
          </Typography>
        )}
        <Typography
          component="span"
          style={{
            fontFamily: 'Overpass',
            fontWeight: 600,
            fontSize: '14px',
            color: midGray,
            verticalAlign: 'middle',
            textAlign: 'center',
            alignItems: 'center',
          }}
        >
          {BrokerCreditRatingCategoryTextMap[creditRatingCategory as BrokerCreditRatingCategory]}
        </Typography>
      </>
    )
  }

  if (isHorizontal) {
    return (
      <FlexBox gap="10px">
        <Text variant="paragraph1">{creditRatingCategoryName}</Text>
        {creditRatingAndCategory()}
      </FlexBox>
    )
  }

  return (
    <Labeled
      label={<div style={{ paddingLeft: paddingName }}>Broker credit rating</div>}
      style={{ paddingLeft: paddingScore }}
    >
      <FlexBox gap="10px">{creditRatingAndCategory()}</FlexBox>
    </Labeled>
  )
}
